import React from "react";
import "./Profile.css";
import { ScrollService } from "../../../componets/ScrollService";

export function Profile() {
  return (
    <div className={"profile-container"}>
      <div className={"profile-parent"}>
        <div className={"profile-details"}>
          <div className={"profile-details-name"}>
            <span className={"primary-text"}>
              {" "}
              Hello, I'm <span className="highlighted-text"> Andreas</span>
            </span>
          </div>
          <div className={"colz"}>
            <div className={"colz-icon"}>
              <a href={"https://www.linkedin.com/in/andreas-baade-958bba244/"}>
                <i className={"fa fa-linkedin-square"} />
              </a>
              <a href={"https://github.com/a-baade"}>
                <i className={"fa fa-github"} />
              </a>
            </div>
          </div>
          <div className={"profile-details-role"}>
            <span className={"primary-text"}>
              {" "}
              <h1>{"Ready for work"}</h1>
              <span className={"profile-role-tagline"}>
                <br />
                Bachelors in IT with a specialization in Frontend and Mobile
                Development. And a lot of personal projects and self study.
                <br />
                Initiative, cooperative, congenial, dedicated and a fast learner
              </span>
            </span>
          </div>
          <div className={"profile-options"}>
            <button
              className={"btn primary-btn"}
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Contact me{""}
            </button>
            <button
              className={"btn highlighted-btn"}
              onClick={() => ScrollService.scrollHandler.scrollToCV()}
            >
              {""}
              Go to my CV{""}
            </button>
          </div>
        </div>
        <div className={"profile-pic"}>
          <div className={"profile-pic-background"} />
        </div>
      </div>
    </div>
  );
}
